export default __webpack_public_path__ + "static/media/date.0d998b33.svg";